import { render, staticRenderFns } from "./package_title.vue?vue&type=template&id=7512b732&"
import script from "./package_title.vue?vue&type=script&lang=js&"
export * from "./package_title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports